import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

@Injectable()
export class TimeZoneInterceptor implements HttpInterceptor 
{

	constructor(private readonly localStorageService: LocalStorageService) {}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> 
	{
		const timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
		if (timeZone !== '' && timeZone !== null) 
		{
			request = request.clone({
				setHeaders: { ClientTimeZone: timeZone }
			});
		}
		const lang: string | null = this.localStorageService.getLanguage();
		if(lang !== '' && lang !== null)
		{
			request = request.clone({
				setHeaders: { language: lang }
			});
		}
		const isImpersonatedUser: string | null = this.localStorageService.getImpersonateUser();
		if(isImpersonatedUser !== '' && isImpersonatedUser !== null)
		{
			const parsedData = JSON.parse(isImpersonatedUser);
			request = request.clone({
				setHeaders: { impersonateuser: parsedData.email }
			});
		}

		return next.handle(request);
	}
}
